import apolloClient from '@/graphql/apollo'
import { GET_CART } from '@/graphql/queries/cart'
import { REMOVE_CART_ITEM, UPDATE_CART_ITEM } from '@/graphql/mutations/cart'

const fetchCart = async function(context, params) {
  const response = await apolloClient.query({
    query: GET_CART,
    variables: {
      id: params.id
    }
  })

  context.commit('SET_CART', response.data.cart)
}

const removeCartItem = async function(context, id) {
  const response = await apolloClient.mutate({
    mutation: REMOVE_CART_ITEM,
    variables: {
      id: id
    }
  })

  context.commit('REMOVE_CART_ITEM', response.data.removeCartItem.id)
}

const setLoading = async function(context, value) {
  context.commit('SET_LOADING', value)
}

const updateCartItem = async function(context, params) {
  const response = await apolloClient.mutate({
    mutation: UPDATE_CART_ITEM,
    variables: {
      id: params.id,
      quantity: params.quantity
    }
  })

  context.commit('UPDATE_CART_ITEM', response.data.updateCartItem)
}

export default {
  fetchCart,
  removeCartItem,
  setLoading,
  updateCartItem
}
